module.exports = __webpack_public_path__ + "static/media/DS.2e477a8c.png";